<template>
  <div v-if="cargando">Cargando</div>
  <div v-else>
    <template v-if="version.elements2">
      <div v-if="version.elements2.length">
        <p class="md-headline">Motor</p>
        <div class="row">
          <boton-panel
              v-for="item in version.elements2"
              :key="item.id"
              :datos="item"
              v-model="formulario.motor"
              :valor="formulario.motor"
          />
        </div>
      </div>
    </template>
    <template v-if="version.elements3">
      <div v-if="version.elements3.length">
        <p class="md-headline">Transmisión</p>
        <div class="row">
          <boton-panel
              v-for="item in version.elements3"
              :key="item.id"
              :datos="item"
              v-model="formulario.transmision"
              :valor="formulario.transmision"
          />
        </div>
      </div>
    </template>
    <template v-if="version.elements4">
      <div v-if="version.elements4.length">
        <p class="md-headline">Tracción</p>
        <div class="row">
          <boton-panel
              v-for="item in version.elements4"
              :key="item.id"
              :datos="item"
              v-model="formulario.traccion"
              :valor="formulario.traccion"
          />
        </div>
      </div>
    </template>
    <div class="pt-5 d-flex justify-content-between">
      <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i
          class="flaticon2-back"></i> Regresar
      </button>
      <button type="button"
              :class="estadoBtn ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"
              class="btn btn-primary btn-font-sm" v-on:click="siguiente"
              :disabled="estadoBtn || !paquetes.length"> Continuar <i class="flaticon2-next"></i></button>
    </div>
  </div>
</template>

<script>
import BotonPanel from "../../../componentes/boton-panel"

export default {
  name: "potencia",
  data: () => ({
    permitir: false,
    formulario: {
      motor: {id: null},
      transmision: {id: null},
      traccion: {id: null},
    }
  }),
  props: {
    estadoBtn: {
      type: Boolean
    },
    cargando: {
      type: Boolean
    },
    version: {
      type: Object,
      default: () => ({
        elements2: [],//motores
        elements3: [],//transmision
        elements4: [],//traccion
        ndt3: null,
        ndt4: null,
        ndt5: null,
      })
    },
    paquetes: {
      type: Array,
    },
    value: {
      type: Object,
      default: () => ({
        motor: {id: null},
        transmision: {id: null},
        traccion: {id: null},
      })
    }
  },
  watch: {
    "formulario.motor.id": function () {
      this.$emit('input', this.formulario);
    },
    "formulario.transmision.id": function () {
      this.$emit('input', this.formulario);
    },
    "formulario.traccion.id": function () {
      this.$emit('input', this.formulario);
    },
    paquetes: function (valor) {
      this.$toast.destroy();
      if (valor.length === 0) {
        let moto = this.formulario.motor.dt2 ? `Motor ${this.formulario.motor.dt2}` : "";
        let tran = this.formulario.transmision.dt2 ? `Transmisión ${this.formulario.transmision.dt2}` : "";
        let trac = this.formulario.traccion.dt2 ? `Tracción ${this.formulario.traccion.dt2}` : "";
        this.$toast.show(`Actualmente no disponemos de la versión con ${moto} ${tran} ${trac}`);
      }
    }
  },
  components: {
    BotonPanel
  },
  methods: {
    atras: function () {
      this.$store.commit('setSubActual', 0);
    },
    siguiente: function () {
      this.$store.commit('setSubActual', 2);
    },
    defaultMotor: function () {
      const vector = this.version.elements2 ? this.version.elements2 : [];
      try {
        const aux = vector.find(i => i.id === this.value.motor.id);
        if (aux)
          this.formulario.motor = aux;
        else
          throw "Not found motor";
      } catch (e) {
        const aux2 = vector.find(i => i.id === this.version.ndt3);
        this.formulario.motor = aux2 ? aux2 : {id: this.version.ndt3};
      }
    },
    defaultTrans: function () {
      const vector = this.version.elements3 ? this.version.elements3 : [];
      try {
        const aux = vector.find(i => i.id === this.value.transmision.id);
        if (aux)
          this.formulario.transmision = aux;
        else
          throw "Not found transmision";
      } catch (e) {
        const aux2 = vector.find(i => i.id === this.version.ndt4);
        this.formulario.transmision = aux2 ? aux2 : {id: this.version.ndt4};
      }
    },
    defaultTrac: function () {
      const vector = this.version.elements4 ? this.version.elements4 : [];
      try {
        const aux = vector.find(i => i.id === this.value.traccion.id);
        if (aux)
          this.formulario.traccion = aux;
        else
          throw "Not found traccion";
      } catch (e) {
        const aux2 = vector.find(i => i.id === this.version.ndt5);
        this.formulario.traccion = aux2 ? aux2 : {id: this.version.ndt5};
      }
    },
    cambioValores: function () {
      this.defaultMotor();
      this.defaultTrac();
      this.defaultTrans();
      this.$emit('input', this.formulario);
    }
  },
  created() {
    this.cambioValores();
  }
}
</script>

<style scoped>

</style>
